/** Canonical and /lsc-prefixed billing route paths for LscApp (stream-host alias compatibility). */

export const LSC_BILLING_ROUTE_PATHS = {
  pricing: 'pricing',
  billing: 'billing',
  billingSuccess: 'billing/success',
  billingCanceled: 'billing/canceled',
  lscPricing: 'lsc/pricing',
  lscBilling: 'lsc/billing',
  lscBillingSuccess: 'lsc/billing/success',
  lscBillingCanceled: 'lsc/billing/canceled',
} as const;

export const LSC_BILLING_CANONICAL_PATHS = [
  LSC_BILLING_ROUTE_PATHS.pricing,
  LSC_BILLING_ROUTE_PATHS.billing,
  LSC_BILLING_ROUTE_PATHS.billingSuccess,
  LSC_BILLING_ROUTE_PATHS.billingCanceled,
] as const;

export const LSC_BILLING_STREAM_ALIAS_PATHS = [
  LSC_BILLING_ROUTE_PATHS.lscPricing,
  LSC_BILLING_ROUTE_PATHS.lscBilling,
  LSC_BILLING_ROUTE_PATHS.lscBillingSuccess,
  LSC_BILLING_ROUTE_PATHS.lscBillingCanceled,
] as const;

/** Paths Stripe may redirect to when FRONTEND_URL is main or stream host. */
export const LSC_BILLING_STRIPE_REDIRECT_PATHS = [
  '/billing/success',
  '/billing/canceled',
  '/lsc/billing/success',
  '/lsc/billing/canceled',
] as const;
